import React from 'react';
import {MuiGrid,MuiTypography, muiWithStyles} from '../ui/MaterialUIComponents';

import theme from '../../assests/theme'
import logo from '../ui/icons/logo.png';
const styleSheet = theme => ({
  root: {
    flexGrow: '1',
  },
 
});

const PageContainer=(props)=>(
    <div style={theme.launchPage}>
    <MuiGrid container spacing={0} direction='row' xs={12} >
      {/* <MuiGrid item xs={12} sm={6} style={{ height: '100vh', justifyContent: 'center', alignItems: 'center', display: 'flex', background: theme.palette.primary.lightest}}>
    <div style={{width:"350px",align:'center',height:props.cardHeight,padding:'2%'}} >
           <div style={{textAlign:'center'}}> */}
        {/* <img src={logo} style={{width:'300px',height:'300px'}}/>
      */}
      {/* </div>  </div>
      </MuiGrid> */}
     
     <MuiGrid item xs={12} sm={12} style={{height:'100vh',justifyContent:'center',alignItems:'center',display:'flex',background:'white'}}>
        <div style={{width:"350px",align:'center',height:props.cardHeight,padding:'2%'}} >
        
          {props.children}
        </div>
      </MuiGrid>
    </MuiGrid>
  </div> 
)
export default muiWithStyles(styleSheet)(PageContainer);